








































import { Vue, Component, Prop } from 'nuxt-property-decorator'
import { VPopover } from 'v-tooltip'
import {
  mdiExportVariant,
  mdiContentCopy,
  mdiCheckCircleOutline,
} from '@mdi/js'
import {
  vkIcon,
  odnoklassnikiIcon,
  whatsappIcon,
  telegramIcon,
} from '~/assets/images/social/images'
import ComponentImage from '~/components/images/image.vue'
import ComponentIcon from '~/components/icon/icon.vue'

@Component({
  components: {
    VPopover,
    ComponentIcon,
    ComponentImage,
  },
})
export default class ComponentProductShareButton extends Vue {
  @Prop({ type: String, default: '' }) readonly url!: string
  @Prop({ type: String, default: '' }) readonly title!: string
  @Prop({ type: String, default: '' }) readonly image!: string

  private icons = {
    mdiCheckCircleOutline,
    mdiExportVariant,
    mdiContentCopy,
  }

  private socialIcons = {
    vk: vkIcon,
    odnoklassniki: odnoklassnikiIcon,
    whatsapp: whatsappIcon,
    telegram: telegramIcon,
  }

  private urlIsCopied = false

  private get copyLinkIcon() {
    return this.urlIsCopied
      ? this.icons.mdiCheckCircleOutline
      : this.icons.mdiContentCopy
  }

  private get copyLinkText() {
    return this.urlIsCopied ? 'Ссылка скопирована' : 'Скопировать ссылку'
  }

  private copyUrl() {
    navigator.clipboard.writeText(this.url)
    this.urlIsCopied = true
    setTimeout(() => {
      this.urlIsCopied = false
    }, 5000)
  }

  private get vkShareLink() {
    let result = 'https://vk.com/share.php?'
    result += 'url=' + encodeURIComponent(this.url)
    result += this.title ? '&title=' + encodeURIComponent(this.title) : ''
    result += this.image ? '&image=' + encodeURIComponent(this.image) : ''
    return result
  }

  private get odnoklassnikiShareLink() {
    let result = 'https://connect.ok.ru/offer?'
    result += 'url=' + encodeURIComponent(this.url)
    result += this.title ? '&title=' + encodeURIComponent(this.title) : ''
    result += this.image ? '&imageUrl=' + encodeURIComponent(this.image) : ''
    return result
  }

  private get telegramShareLink() {
    let result = 'https://t.me/share/url?'
    result += 'url=' + encodeURIComponent(this.url)
    result += this.title ? '&text=' + encodeURIComponent(this.title) : ''
    return result
  }

  private get whatsAppShareLink() {
    let result = 'https://wa.me/?'
    result +=
      'text=' +
      encodeURIComponent(this.title ? `${this.title} ${this.url}` : this.url)
    return result
  }

  private get socials() {
    return [
      {
        icon: this.socialIcons.vk,
        shareLink: this.vkShareLink,
        title: 'ВКонтакте',
      },
      {
        icon: this.socialIcons.odnoklassniki,
        shareLink: this.odnoklassnikiShareLink,
        title: 'Одноклассники',
      },
      {
        icon: this.socialIcons.telegram,
        shareLink: this.telegramShareLink,
        title: 'Telegram',
      },
      {
        icon: this.socialIcons.whatsapp,
        shareLink: this.whatsAppShareLink,
        title: 'WhatsApp',
      },
    ]
  }

  private openPopup(url: string) {
    window.open(url)
  }
}
